export const dropdownOptions = [
  { id: 'liveboard', label: 'Liveboard' },
  { id: 'search', label: 'Search data' },
  { id: 'home', label: 'Full App' },
  { id: 'viz', label: 'Viz' },
];

export const links = [
  { id: 'liveboard', label: 'Liveboard' },
  { id: 'search', label: 'Search data' },
  { id: 'home', label: 'Full App' },
  { id: 'viz', label: 'Viz' },
];

export const spotterLink = [{ id: 'spotter', label: 'Spotter' }];

export const fullAppLinks = [
  { id: '/', label: 'Home' },
  { id: '/answers', label: 'Answers' },
  { id: '/pinboards', label: 'Liveboards' },
  { id: '/monitor', label: 'Monitor' },
  { id: '/search', label: 'Search' },
  { id: '/data', label: 'Data' },
  { id: '/insights', label: 'SpotIQ' },
];
